import React from 'react';
import {Tabs} from "@mui/material";

const TabCardInterior = (props) => {
    const {children, ...rest} = props;

    return (
        <Tabs className={"interior-tabs"} {...rest}>
            {children}
        </Tabs>
    );
};

export default TabCardInterior;